import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import MobileMenuButton from './MobileMenuButton';
import AnalyticsChartFullscreenButton from '../pages/components/analytics/AnalyticsChartFullscreenButton';

export const MOBILE_TOPBAR_GUTTER_X = 'px-[16px]';
export const MOBILE_TOPBAR_PAD_TOP = 'pt-[8px]';
export const MOBILE_TOPBAR_ROW_GAP = 'gap-x-2';
export const MOBILE_TOPBAR_CONTENT_GAP_H = 'h-[32px]';
/**
 * Height of every control that sits in the mobile top bar row — kept identical
 * to MobileMenuButton's box so the page's selector/fullscreen button read as the
 * same size as the hamburger, not just centered against it.
 */
export const MOBILE_TOPBAR_CONTROL_H = 'h-[36px] sm:h-[40px]';

const MobilePageTopBar = ({ onMenuClick, isFullscreen = false, onEnterFullscreen, onExitFullscreen, withContentGap = true, children }) => {
  const { t } = useTranslation();
  const outletContext = useOutletContext() || {};
  const handleMenuClick = onMenuClick ?? outletContext.onMenuClick;
  const showMenu = !!handleMenuClick && !isFullscreen;
  const showFullscreen = !!onEnterFullscreen && !!onExitFullscreen;
  return (
    <div className="lg:hidden">
      {/* `items-center`: the hamburger is 36px (40px at sm+) while every page's
          top-bar content is a 32px control, so top-aligning left them visibly
          high against the button — center the row instead. */}
      <div className={`grid grid-cols-[auto_minmax(0,1fr)_auto] items-center ${MOBILE_TOPBAR_ROW_GAP} ${MOBILE_TOPBAR_GUTTER_X} ${MOBILE_TOPBAR_PAD_TOP}`}>
        {showMenu && (
          <MobileMenuButton onClick={() => handleMenuClick?.()} className="col-start-1 shrink-0" ariaLabel={t('nav.toggleMenu', 'Toggle menu')} />
        )}
        <div className="col-start-2 min-w-0">{children}</div>
        {showFullscreen && (
          <div className="col-start-3">
            <AnalyticsChartFullscreenButton compact heightClass={MOBILE_TOPBAR_CONTROL_H} isActive={isFullscreen} onEnter={onEnterFullscreen} onExit={onExitFullscreen} />
          </div>
        )}
      </div>
      {withContentGap && <div className={`${MOBILE_TOPBAR_CONTENT_GAP_H} shrink-0`} />}
    </div>
  );
};
export default MobilePageTopBar;
